import { render } from "./ResourcesGoal5a.vue?vue&type=template&id=53d9b03f"
import script from "./ResourcesGoal5a.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal5a.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__